/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import Diagram from '@/components/diagram/Diagram';
import * as APPDATA from '@/constants/pcConstAppData';

import '../StatusPage.less';

@connect((store) => {
  const {currentPCState, recoveryOfLiquidStatus, isPCRunning, isPCPaused} = store.setupStore;

  const currentState =
    currentPCState === APPDATA.PC_RECOVERING_STATE
      ? `${APPDATA.PC_RECOVERING_STATE}-${recoveryOfLiquidStatus[APPDATA.KEY.CurrentRecoveryStatus]}`
      : currentPCState;

  return {
    isPCRunning,
    isPCPaused,
    currentState,
  };
})
class StatusDiagram extends React.PureComponent {
  render() {
    const {isPCPaused, currentState, isPCRunning} = this.props;
    console.log({render: 'StatusDiagram', isPCPaused, currentState, isPCRunning});

    return (
      <Diagram
        isPaused={isPCPaused}
        isRunning={isPCRunning}
        currentState={currentState}
      />
    );
  }
}
export default StatusDiagram;
